
const isApiWhitelisted = path => {
    if (path === '/hms_ms/api/v1/users/generate_otp'
        || path === '/hms_ms/api/v1/users/new_sign_in'
        || path === '/hms_ms/api/v1/users/sign_in_by_phone'
        || path === '/hms_ms/api/v1/users/web_sign_up'
        || path === '/hms_ms/api/v1/users/verify_otp_and_authenticate'
        || path === '/hms_ms/api/v1/onboard/users/sign_out'
        || path === '/hms_ms/api/v2/sign_in'
        || path === '/hms_ms/api/v2/request_otp'
        || path === '/hms_ms/api/v2/verify_otp'
        || path === '/hms_ms/api/v1/users/forgot_password'
        || path === '/hms_ms/api/v1/users/password'
        || path === '/hms_ms/api/v1/global_info'
        || path === '/hms_ms/api/v1/users/social_media_login'
        || path === '/hms_ms/api/v1/generic/anonymous/page_widgets_details'
        || path === '/global_info'
        || path === '/getLoginApiHealthStatus'
        || path === '/users/sign_in'
        || path.includes('/users/generate_otp')
        || path.includes('/users/sign_in_by_phone')
        || path.includes('/users/forgot_password')
        || path.includes('/users/password')
        || path.includes('/users/sso/sign_in/info')
        || path.includes('/users/change_password')
        || path.includes('/hms_ms/api/v1/payment/get_hotel_data')
        || path.includes('/hms_ms/api/v1/payment/create_order')
        || path.includes('/hms_ms/api/v1/payment/verify')
        || path.includes('/hms_ms/api/v1/payment/post_payment_data')
        || path.includes('/api/getPaymentToken')
    ) {
        return true;
    }
    return false
}

export default isApiWhitelisted;
